import React from 'react'
import { HeroshotBanner as CHeroshotBanner } from '@usap/widgets'

export default function HeroshotBanner({ dynamicApiData }) {
  if (!dynamicApiData.heroshot || typeof dynamicApiData.heroshot.title === 'undefined') {
    return null
  }

  const {
    title,
    description,
    alt,
    desktop,
    mobile,
    defaultDesktop,
    defaultMobile,
  } = dynamicApiData.heroshot

  const data = {
    partName: title,
    subText: description,
    backgroundImageDesktop: desktop,
    backgroundImageMobile: mobile,
    backgroundImageDesktopDefault: defaultDesktop,
    backgroundImageMobileDefault: defaultMobile,
    alt,
  }
  return (
    <CHeroshotBanner data={data} />
  )
}
